import { TextField } from '@mui/material';
import { Box } from '@mui/system';

import { FC } from 'react';
import { ReactSetState } from '../../models';

export interface INumberOnlyCell {
  index: number;
  value: any;
  setValue: ReactSetState<any>;
  hasChanges: boolean;
  setHasChanges: ReactSetState<boolean>;
  setRows: ReactSetState<any>;
  original: any;
  propertyName: string;
  placeholder: string;
}
export const NumberOnlyCell: FC<INumberOnlyCell> = ({
  index,
  value,
  setValue,
  hasChanges,
  setHasChanges,
  setRows,
  original,
  propertyName,
  placeholder,
}) => {
  return (
    <Box width="100%">
      {/* {console.log(index)} */}
      <TextField
        fullWidth
        inputProps={{
          id: `${propertyName}-${index}`,
        }}
        placeholder={placeholder}
        value={value}
        onChange={e => {
          const re = /^-?[0-9\b]+$/;
          // make sure it is number only before we update state
          const isNumber = re.test(e.target.value);
          const isEmptyString = e.target.value === '';
          if (isNumber) {
            setValue(+e.target.value);
          }
          if (isEmptyString) {
            setValue('');
          }
        }}
        // Once the user leaves the input, take the changes they've written and commit
        // them to local state. This readies these changes for the ultimate batch save action.

        onBlur={e => {
          // If user clicked away and changes have not been saved, enforce the viewport does not move.

          setRows((state: any) => {
            const accountIndex = state.indexOf(original);

            // Enable save button
            if (state[accountIndex][propertyName] !== value) {
              setHasChanges(true);
              // state[accountIndex].isEdited = true;
            }

            // Store changes in preparation for batch save
            state[accountIndex][propertyName] = typeof value === 'string' ? 0 : value;
            return JSON.parse(JSON.stringify(state));
          });
        }}
      />
    </Box>
  );
};
